import React, { forwardRef, useContext } from 'react'
import { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Button, Col, Form, Input, Modal, notification, Row, Space } from 'antd'
import { EditableList } from '../../compnents/list/EditableList'
import { ProcurementColumns, SearchColumns } from './columns'
import { unwrapResult } from '@reduxjs/toolkit'
import { RootDispatch } from '../../app/store'
import { TabBar, TabPane } from '../../compnents/widgets/TabBar'
import styles from './appllication.module.css'
import { ThemeContext } from '../../theme/ThemeContext'
import moment from 'moment'
import {
  DateTimeFormatSimple,
  DateTimeFormatSimpleOnly,
} from '../../models/datetime'
import { ProcurementQuery } from './Query'
import { Category } from '../../models/category'
import { selectChainId, selectTenantId } from '../../app/applicationSlice'
import {
  getchainInventoryReceiptslist,
  getInsertInptPoFn,
  getPurchaseBusinessListFn,
  getPurchaseBusinessRemoveFn,
  getPurchaseBusinessWithdrawFn,
  getRemoveReceiptsFn, purchaseBusinessExportExcelAsync,
  queryInboundDAsync,
  queryInboundOperateInventoryFn,
} from './chainSlice'
import { ExclamationCircleFilled } from '@ant-design/icons'
import { useHistory, useLocation } from 'react-router-dom'
import { traceRoute } from '../../layouts/layoutSlice'
import { DateRangeType, getDateRange } from '../../compnents/form/DateSelect'
import { AcceptanceModal } from './AcceptanceModal'
import { StorageModal } from './StorageModal'
import { NavBar } from '../../compnents/nav/NavBar'
import { getCheckPermissionAsync } from '../FunctionSetting/dataPermission/dataPermissionSlice'
import { SJQXChecks } from '../../models/dataPersion'

export const ProcurementBusinessNewRef = () => {
  const theme = useContext(ThemeContext)

  const [form] = Form.useForm()

  const history = useHistory()

  const location: any = useLocation()

  const tenantId = useSelector(selectTenantId)

  const chainId = useSelector(selectChainId)

  const dispatch = useDispatch<RootDispatch>()

  const [params, setParams] = useState<any>({ current: 1, size: 10 })

  const [page, setPage] = useState<any>({ items: [], total: 0 })

  const [pageLoading, setPageLoading] = useState(false)
  
  const [exportBtnLoading, setExportBtnLoading] = useState(false)

  const [searchVisible, setSearchVisible] = useState(false)

  const [acceptanceVisible, setAcceptanceVisible] = useState(false)

  const [storageVisible, setStorageVisible] = useState(false)

  const [searchParams, setSearchParams] = useState<any>({
    current: 1,
    size: 10,
  })

  const [searchPage, setSearchPage] = useState<any>({ items: [], total: 0 })

  const [pageSearchLoading, setPageSearchLoading] = useState(false)

  const [timeHead, timeTail] = getDateRange(DateRangeType.Today)

  const [rowData, setRowData] = useState<any>({})

  useEffect(() => {
    if (params.current != 0) {
      getPageList()
    }
  }, [params])

  const getPageList = () => {
    setPageLoading(true)
    dispatch(
      getPurchaseBusinessListFn({
        ...params,
        recepitsDateStart: params?.recepitsDateStart
          ? params?.recepitsDateStart
          : timeHead,
        recepitsDateEnd: params?.recepitsDateEnd
          ? params?.recepitsDateEnd
          : timeTail,
        category: Category.CGYW,
      })
    )
      .then(unwrapResult)
      .then((res: any) => {
        setPage({
          items: res.records,
          total: res.total,
        })
      })
      .finally(() => setPageLoading(false))
  }
  const outExportExcel = () => {
    setExportBtnLoading(true)
    dispatch(
      purchaseBusinessExportExcelAsync({
        ...params,
        recepitsDateStart: params?.recepitsDateStart
          ? params?.recepitsDateStart
          : timeHead,
        recepitsDateEnd: params?.recepitsDateEnd
          ? params?.recepitsDateEnd
          : timeTail,
        category: Category.CGYW,
      })
    )
      .then(unwrapResult)
      .then((res: any) => {
        const content = res
        const blob = new Blob([content])
        const fileName = '采购单.xlsx'
        const selfURL = window[window.webkitURL ? 'webkitURL' : 'URL']
        const elink = document.createElement('a')
        if ('download' in elink) {
          elink.download = fileName
          elink.style.display = 'none'
          elink.href = selfURL['createObjectURL'](blob)
          document.body.appendChild(elink)
          // 触发链接
          elink.click()
          selfURL.revokeObjectURL(elink.href)
          document.body.removeChild(elink)
        } else {
          return (navigator as any).msSaveBlob(blob, fileName)
        }
      })
      .then(() => {
        notification.success({
          message: '导出成功',
          duration: 3,
        })
      })
      .finally(() => setExportBtnLoading(false))
  }

  useEffect(() => { 
    if(searchVisible) {
      dispatch(queryInboundDAsync({
        inventoryReceiptsId: rowData.id,
        type: 0,
        ...searchParams
      }))
        .then(unwrapResult)
        .then((res: any) => {
          setSearchPage({
            items: res.records,
            total: res.total,
          })
          setSearchVisible(true)
        })
    }
  }, [searchParams])

  return (
    <Col
      style={{
        height: '100%',
        margin: '0px 20px',
      }}
    >
      <Col
        style={{
          margin: '10px 0px',
        }}
      >
        <NavBar
          where={['库房业务', '采购业务']}
          backtrace={{
            name: '库房工作站',
            path: '/storage/station',
            state: { category: location?.state?.category },
          }}
        />
      </Col>
      <div
        style={{
          height: 'calc(100% - 70px)',
          margin: '10px 0',
          padding: '20px',
          background: '#fff',
          borderRadius: '10px',
          position: 'relative',
        }}
      >
        <ProcurementQuery
          loading={pageLoading}
          type={2}
          onValueChange={(v: any) => {
            setParams({
              ...params,
              ...v,
              current: 1,
              recepitsDateStart: v?.recepitsDateStart
                ? v?.recepitsDateStart
                : timeHead,
              recepitsDateEnd: v?.recepitsDateEnd
                ? v?.recepitsDateEnd
                : timeTail,
              timeHead: undefined,
              timeTail: undefined,
            })
          }}
          exportExcel={() => {
            dispatch(getCheckPermissionAsync({ itemCode: SJQXChecks.KFGZZDCDYQX }))
              .then(unwrapResult)
              .then((res: any) => {
                outExportExcel()
              })
          }}
          exportBtnLoading={exportBtnLoading}
        />
        <div style={{ height: '100%', overflowY: 'hidden' }}>
          <EditableList
            style={{ height: '88%', overflowY: 'auto' }}
            scroll={{ x: '40rem' }}
            loading={pageLoading}
            page={{
              items: page.items,
              current: params.current,
              size: params.size,
              total: page.total,
            }}
            onRow={(r) => ({
              onDoubleClick: () => {
                history.push({
                  pathname: '/chainPutList',
                  state: {
                    where: ['库房工作站', '采购业务'],
                    name: '单据列表',
                    backName: '库房工作站',
                    path: '/procorementBusiness',
                    category: Category.CGYW,
                    selectId: r.id,
                    detail: { ...r, type: 2 },
                    approvedUserName: r?.approvedUserName,
                  },
                })
              },
            })}
            pageSizeOptions={['10', '20', '50', '100']}
            rowKey={(m: any) => m.id}
            columns={ProcurementColumns(
              params.size * (params.current - 1),
              2,
              (action: any, t: any) => {
                switch (action) {
                  case 'list':
                    setParams({ ...params })
                    break
                  case 'delete':
                    Modal.confirm({
                      centered: true,
                      title: '确认操作',
                      content: (
                        <div>
                          <ExclamationCircleFilled
                            style={{ color: '#FFAE55', fontSize: 18 }}
                          />
                          &nbsp;是否确认删除？
                        </div>
                      ),
                      okText: '确认',
                      cancelText: '取消',
                      icon: null,
                      onOk: () => {
                        dispatch(getPurchaseBusinessRemoveFn(t.id))
                          .then(unwrapResult)
                          .then(() => {
                            notification.success({
                              message: '删除成功',
                            })
                            setParams({ ...params })
                          })
                      },
                    })
                    break
                  case 'revocation':
                    Modal.confirm({
                      centered: true,
                      title: '确认操作',
                      content: (
                        <div>
                          <ExclamationCircleFilled
                            style={{ color: '#FFAE55', fontSize: 18 }}
                          />
                          &nbsp;是否确认撤回？
                        </div>
                      ),
                      okText: '确认',
                      cancelText: '取消',
                      icon: null,
                      onOk: () => {
                        dispatch(getPurchaseBusinessWithdrawFn(t.id))
                          .then(unwrapResult)
                          .then(() => {
                            notification.success({
                              message: '撤回成功',
                            })
                            setParams({ ...params })
                          })
                      },
                    })
                    break
                  case 'upload':
                    Modal.confirm({
                      centered: true,
                      title: '确认操作',
                      content: (
                        <div>
                          <ExclamationCircleFilled
                            style={{ color: '#FFAE55', fontSize: 18 }}
                          />
                          &nbsp;是否确认上传？
                        </div>
                      ),
                      okText: '确认',
                      cancelText: '取消',
                      icon: null,
                      onOk: () => {
                        dispatch(getInsertInptPoFn(t.id))
                          .then(unwrapResult)
                          .then(() => {
                            notification.success({
                              message: '上传成功',
                            })
                            setParams({ ...params })
                          })
                      },
                    })
                    break
                  case 'search':
                    setRowData(t)
                    dispatch(queryInboundDAsync({
                      inventoryReceiptsId: t.id,
                      type: 0,
                      ...searchParams
                    }))
                      .then(unwrapResult)
                      .then((res: any) => {
                        setSearchPage({
                          items: res.records,
                          total: res.total,
                        })
                        setSearchVisible(true)
                      })
                    break
                  case 'acceptance':
                    setRowData(t)
                    setAcceptanceVisible(true)
                    break
                  case 'storage':
                    setRowData(t)
                    setStorageVisible(true)
                    break
                }
              },
              Category.CGYW
            )}
            onChangePage={(current, size) =>
              setParams({ ...params, current, size: size || 10 })
            }
            sticky
          />
        </div>
      </div>

      <Modal
        title={'入库结果查询'}
        visible={searchVisible}
        centered
        width={'80%'}
        footer={null}
        destroyOnClose
        onCancel={() => {
          setSearchVisible(false)
        }}
      >
        <EditableList
          style={{ flex: 1 }}
          scroll={{ x: '30rem' }}
          loading={pageSearchLoading}
          page={{
            items: searchPage.items,
            current: searchParams.current,
            size: searchParams.size,
            total: searchPage.total,
          }}
          pageSizeOptions={['10', '20', '50', '100']}
          rowKey={(m: any) => m.id}
          columns={[
            {
              title: '药品名称',
              align: 'center',
              dataIndex: 'name',
              width: '8rem',
              ellipsis: true,
            },
            {
              title: '批次号',
              align: 'center',
              dataIndex: 'batchNo',
              width: '6rem',
              ellipsis: true,
            },
            {
              title: '生产日期',
              align: 'center',
              dataIndex: 'productDate',
              width: '8rem',
              ellipsis: true,
              render: (_, t) => {
                return t.productDate
                  ? moment(t.productDate).format(DateTimeFormatSimple)
                  : '-'
              },
            },
            {
              title: '有效期',
              align: 'center',
              dataIndex: 'deadline',
              width: '8rem',
              ellipsis: true,
              render: (_, t) => {
                return t.deadline
                  ? moment(t.deadline).format(DateTimeFormatSimple)
                  : '-'
              },
            },
            {
              title: '收货数量',
              align: 'center',
              dataIndex: 'count',
              width: '8rem',
              ellipsis: true,
            },
            {
              title: '隔离数量',
              align: 'center',
              dataIndex: 'isolationCount',
              width: '8rem',
              ellipsis: true,
            },
            {
              title: '待验数量',
              align: 'center',
              dataIndex: 'pendingVerificationCount',
              width: '8rem',
              ellipsis: true,
            },
            {
              title: '收货日期',
              align: 'center',
              dataIndex: 'upAccountTime',
              width: '8rem',
              ellipsis: true,
              render: (_, t) => {
                return t.upAccountTime
                  ? moment(t.upAccountTime).format(DateTimeFormatSimple)
                  : '-'
              },
            },
            // {
            //   title: "收货人",
            //   align: "center",
            //   dataIndex: "upAccountUserName",
            //   width: "8rem",
            //   ellipsis: true,
            // },
          ]}
          onChangePage={(current, size) =>
            setSearchParams({ ...searchParams, current, size: size || 10 })
          }
          sticky
        />
        {rowData?.storehouseTag == '210' && (
          <Row justify='end' style={{ marginTop: '20px' }}>
            <Space>
              <Button onClick={() => setSearchVisible(false)}>取消</Button>
              <Button
                type='primary'
                onClick={() => {
                  Modal.confirm({
                    centered: true,
                    title: '确认操作',
                    content: (
                      <div>
                        <ExclamationCircleFilled
                          style={{ color: '#FFAE55', fontSize: 18 }}
                        />
                        &nbsp;是否确认入库？
                      </div>
                    ),
                    okText: '确认',
                    cancelText: '取消',
                    icon: null,
                    onOk: () => {
                      dispatch(queryInboundOperateInventoryFn(rowData?.id))
                        .then(unwrapResult)
                        .then(() => {
                          notification.success({
                            message: '操作成功',
                          })
                          setSearchVisible(false)
                          setParams({ ...params, current: 1 })
                        })
                    },
                  })
                }}
              >
                确认入库
              </Button>
            </Space>
          </Row>
        )}
      </Modal>

      <AcceptanceModal
        data={rowData}
        category={Category.CGYW}
        visible={acceptanceVisible}
        onCancel={() => setAcceptanceVisible(false)}
        onOk={() => {
          setAcceptanceVisible(false)
          setParams({ ...params, current: 1 })
        }}
      />

      <StorageModal
        data={rowData}
        visible={storageVisible}
        category={Category.CGYW}
        onCancel={() => setStorageVisible(false)}
        onOk={() => {
          setStorageVisible(false)
          setParams({ ...params, current: 1 })
        }}
      />
    </Col>
  )
}

export const ProcurementBusinessNew = forwardRef(ProcurementBusinessNewRef)
